
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/map",
      function () {
        return require("private-next-pages/map/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/map"])
      });
    }
  